import { RATING } from "../constants";
import { instance } from "../../axios";

// Admin only: every app rating, its summary and what we know of each rater
const getRatingsAction = () => {
  return (dispatch) => {
    dispatch({ type: RATING.GET_RATINGS });
    instance
      .get("/rating")
      .then((results) => {
        dispatch({ type: RATING.GET_RATINGS_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: RATING.GET_RATINGS_FAILURE, payload: error });
      });
  };
};

export { getRatingsAction };
